// Catch-all for React Router SPA; more specific routes (e.g. `/`) win first.
export default "/*";
